namespace RS.ExternalHelp
{
    export class TurboPlugin extends RS.ExternalHelp.VisitorPlugin
    {
        private readonly _showTurboMode: boolean;

        public constructor(page: RS.ExternalHelp.IPage)
        {
            super(page);

            this._showTurboMode = RS.URL.getParameterAsBool("turbo", false);
        }

        public onElementLoaded(element: HTMLElement): void
        {
            if (element.id === "turbo" && !this._showTurboMode)
            {
                RS.ExternalHelp.hideElement(element);
            }
        }
    }
    RS.ExternalHelp.pluginRegistry.register(TurboPlugin);
}